module.exports = __webpack_public_path__ + "static/media/boloauto.0a06ff81.svg";